import { useTranslation as useI18nTranslation } from 'react-i18next';

/**
 * The shape of a bound `t` as plain (non-React) helpers take it — column
 * builders, decorators, label functions. Narrower than i18next's `TFunction`
 * on purpose, so a test can pass a stub.
 */
export type TranslateFn = (key: string, options?: Record<string, unknown>) => string;

export const useTranslation = (namespace?: string) => {
  return useI18nTranslation(namespace || 'common');
};

export default useTranslation;